import { NgModule } from "@angular/core";
import { ScrollTopFloatingComponent } from "./scroll-top-floating.component";
import { CommonModule } from "@angular/common";
import { CcScrollToTopDirective } from "src/app/directives/cc-scroll-to-top.directive";

@NgModule({
  declarations:[ScrollTopFloatingComponent,CcScrollToTopDirective],
  imports: [CommonModule],
  exports:[ScrollTopFloatingComponent,CommonModule]
})

export class ScrollTopModule {}